define('SageDotCom/DataLayer/Events/iAdvizeCallBack',[
    'jquery',
    "SageDotCom/DataLayer/Events/eventBase"
], function ($, EventBase) {

    function iAdvizeCallBackInteractionEvent(scope) {
        EventBase.call(this);

        //var location = this.getLocation(scope);
        //var id = getIAdvizeCallbackId(scope);

        this.props = {
            "event_name": "form_submit_success",
            "event_non-int ": "0",
            "event_category": "contact",
            'event_action': 'form submit',
            "event_label": "successful",
            "event_name_level_1": "not set",
            "event_name_level_2": '#callback',
            "event_name_level_3": 'call-back-popup',
            "event_name_level_4": 'Appelez-moi',
            "event_name_level_5": 'CL_NPS_FR_CON_CallMeBack_COM|BOT|GNRC'
        };
    }

    // There is an id that is needed in the scope so if you get the closest
    // one it will grab id="idzCallOnline" but I need the parent of that
    //function getIAdvizeCallbackId(scope) {

    //    var elem = $(scope).closest("[id^='iadvisebutton']");

    //    if (elem) {
    //        return elem.attr('id');
    //    }

    //    return '';
    //}

    iAdvizeCallBackInteractionEvent.prototype = Object.create(EventBase.prototype);

    return iAdvizeCallBackInteractionEvent;
});
